import SimpleConfirmPage from 'features/membership/components/simple/SimpleConfirmPage';
import useSimpleConfirm from 'features/membership/hooks/useSimpleConfirm';
import {
  COMPLETE_PAGE_PATH,
  FORM_PAGE_PATH
} from 'features/membership/libs/const/memberPagePath';
import { membershipSimpleSettingOptionsState } from 'features/membership/libs/recoil/selector';
import { FC } from 'react';
import { useRecoilValue } from 'recoil';

/**
 * 会員編集入力確認
 */
const SimpleConfirm: FC = () => {
  const { confirmNoticeContentOption } = useRecoilValue(
    membershipSimpleSettingOptionsState
  );
  // simpleの会員編集入力ページのパスを取得
  const formPagePath = FORM_PAGE_PATH.SIMPLE_EDIT;
  const { isMutating, onClickRegisterButton, onClickFixButton, cardNumber } =
    useSimpleConfirm({
      formPagePath,
      completePagePath: COMPLETE_PAGE_PATH.SIMPLE_EDIT_COMPLETE
    });

  return (
    <SimpleConfirmPage
      pageTemplateOptions={{ confirmNoticeContentOption }}
      noticeTextOptionKey="confirmNoticeContentOption"
      cardNumber={cardNumber}
      formPagePath={formPagePath}
      isMutating={isMutating}
      onClickRegisterButton={onClickRegisterButton}
      onClickFixButton={onClickFixButton}
    />
  );
};

export default SimpleConfirm;
